// extracted by mini-css-extract-plugin
export default {"page":"ErrorPage_page__2rWNM","wrapper":"ErrorPage_wrapper__DR5ex","image":"ErrorPage_image__HNeRm","title":"ErrorPage_title__SEONk","text":"ErrorPage_text__s7JUW"};